<template>
  <main>
    <v-container fluid fill-height>
      <v-layout grid align-center justify-center>
          <v-container grid-list-xl text-xs-center>
          <v-layout row wrap>
            <v-flex xs12>
              <img src="/static/img/v.png" alt="Cortexial" class="xs-12">
            </v-flex>
            <v-flex xs12 sm8 offset-sm2 md4 offset-md4>
              <v-form v-if="!registerDone" v-model="valid" ref="form" lazy-validation>
                <v-text-field label="E-mail" autocomplete="username" v-model="email" :rules="emailRules" required ></v-text-field>
                <v-text-field label="Password" autocomplete="new-password" v-model="password" min="8" counter required :append-icon="passwordHidden ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (passwordHidden = !passwordHidden)" :type="passwordHidden ? 'password' : 'text'" :rules="passwordRules"></v-text-field>
                <v-btn large round color="secondary" @click="register" :disabled="!valid || AppState.loading"> Register </v-btn>
              </v-form>
              <h2 v-if="registerDone">Registration succesful.</h2>
              <h3 v-if="registerDone">Logging you in... please wait</h3>
            </v-flex>
          </v-layout>
          </v-container>
      </v-layout>
    </v-container>
  </main>
</template>

<script>
import AppState from "../util/AppState";
import { FirebaseAuth, dbProfile, dbProjects, dbPages } from "../firebase";

export default {
  /* eslint-disable no-useless-escape */
  /* eslint-disable no-mixed-operators */
  data() {
    return {
      AppState,
      valid: true,
      registerDone: true,
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid"
      ],
      password: "",
      passwordHidden: true,
      passwordRules: [
        v => (v && v.length >= 8) || "Password must at least 8 characters"
      ]
    };
  },
  mounted() {
    this.registerDone = false;
  },
  methods: {
    register() {
      if (this.$refs.form.validate()) {
        AppState.loading = true;
        FirebaseAuth.createUserWithEmailAndPassword(this.email, this.password)
          .then(usr => {
            const now = new Date();
            // ADD DEFAULT PROJECT
            dbProjects
              .add({
                userID: usr.uid,
                title: "My Project",
                createdAt: now,
                updatedAt: now
              })
              .then(proj => {
                // ADD DEFAULT PAGE
                dbPages
                  .add({
                    userID: usr.uid,
                    projectID: proj.id,
                    title: "Landing Page",
                    blocks: JSON.stringify([]),
                    blockID: 0,
                    createdAt: now,
                    updatedAt: now
                  })
                  .then(page => {
                    // ADD DEFAULT SETTINGS WITH SELECTED PROJECT
                    proj.update({ activePageID: page.id });
                    dbProfile
                      .doc(usr.uid)
                      .set({
                        userID: usr.uid,
                        currentProjectID: proj.id,
                        currentPageID: page.id,
                        createdAt: now,
                        updatedAt: now
                      })
                      .then(() => {
                        this.registerDone = true;
                        setTimeout(() => {
                          this.$emit("login", usr);
                        }, 2000);
                      })
                      .catch(error => {
                        AppState.error.text = error;
                        AppState.error.show = true;
                      });
                  })
                  .catch(error => {
                    AppState.error.text = error;
                    AppState.error.show = true;
                  });
              })
              .catch(error => {
                AppState.error.text = error;
                AppState.error.show = true;
              });
          })
          .catch(error => {
            AppState.error.text = error;
            AppState.error.show = true;
          });
      }
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/AuthRegister.vue